import { find } from 'lodash'
import React from 'react'
import { Header } from 'semantic-ui-react'
import { ReadOnlyFieldDisplay } from '../../components/ReadOnlyFieldDisplay'
import { numberToCurrency } from '../../utils'
import { helpText, ListingCountryTypeOptions } from './constants'
import { tradeTypeEnumToDisplay } from './helpers'
import styles from './styles.module.less'
import { listingCountryType, SettlementTypeEnum, TradeFormValues } from './Types'

const TradeDetailsPreview = ({ values }: { values: TradeFormValues }) => {
  const formatValue = (value?: number) => (value ? numberToCurrency(value, values.currency) : undefined)

  const actionClassName = values.action ? (values.action.indexOf('Buy') > -1 ? styles.buy : styles.sell) : undefined

  return (
    <div className={`trade-details-preview ${styles.tradeDetailsPreview}`}>
      <Header as="h2">Trade Details</Header>
      <div className={`trade-details-preview-row ${styles.tradeDetailsPreviewRow}`}>
        <ReadOnlyFieldDisplay
          className="security-code-type-preview"
          label="Security Code Type"
          required
          value={values.securityCodeType}
        />
        <ReadOnlyFieldDisplay
          className="symbol-preview"
          helpText={helpText.symbol}
          label="Symbol"
          required
          value={values.symbol.toUpperCase()}
        />
        <ReadOnlyFieldDisplay
          className={`action-preview ${actionClassName}`}
          label="Action"
          required
          value={values.action?.toUpperCase()}
        />
        <ReadOnlyFieldDisplay
          className="quantity-preview"
          label="Quantity"
          required
          value={values.quantity ? `${values.quantity}` : undefined}
        />
        <ReadOnlyFieldDisplay
          className="execution-price-preview"
          label="Execution Price"
          required
          value={formatValue(values.executionPrice)}
        />
      </div>
      <div className={`trade-details-preview-row ${styles.tradeDetailsPreviewRow}`}>
        <ReadOnlyFieldDisplay className="capacity-preview" label="Capacity" required value={values.capacity} />
        <ReadOnlyFieldDisplay
          className="instrument-type-preview"
          label="Instrument Type"
          required
          value={values.instrumentType}
        />
        <ReadOnlyFieldDisplay
          className="trade-type-preview"
          label="Trade Type"
          required
          value={tradeTypeEnumToDisplay(values.tradeType)}
        />
        <ReadOnlyFieldDisplay
          className="listing-country-preview"
          label="Listing Country"
          required
          value={
            find(
              ListingCountryTypeOptions,
              (countryType: listingCountryType) => countryType.value === values.listingCountry
            )?.text
          }
        />
        <ReadOnlyFieldDisplay className="currency-preview" label="Currency" required value={values.currency} />
      </div>
      <div className={`trade-details-preview-row ${styles.tradeDetailsPreviewRow}`}>
        <ReadOnlyFieldDisplay className="trade-date-preview" label="Trade Date" required value={values.tradeDate} />
        <ReadOnlyFieldDisplay className="trade-time-preview" label="Trade Time" value={values.tradeTime} />
        <ReadOnlyFieldDisplay
          className="settlement-type-preview"
          label="Settlement Type"
          required
          value={values.settlementType}
        />
        <ReadOnlyFieldDisplay
          className="settlement-date-preview"
          label="Settlement Date"
          required={values.settlementType === SettlementTypeEnum.specialSettlement}
          value={values.settlementDate}
        />
        <ReadOnlyFieldDisplay className="memo-preview" label="Memo" value={values.memo} />
      </div>
    </div>
  )
}

export default TradeDetailsPreview
